var _path, _rect, _rect2, _rect3, _rect4, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNextMoveIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3001 5.99993C10.3001 8.37471 8.37494 10.2999 6.00011 10.2999C3.62528 10.2999 1.70012 8.37471 1.70012 5.99993C1.70012 3.62515 3.62528 1.7 6.00011 1.7C8.37494 1.7 10.3001 3.62515 10.3001 5.99993Z",
    stroke: "#13BC10",
    strokeWidth: 1.4
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.50006,
    width: 0.999998,
    height: 1.99997,
    rx: 0.499999,
    fill: "#13BC10"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.50006,
    y: 10,
    width: 0.999998,
    height: 1.99997,
    rx: 0.499999,
    fill: "#13BC10"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 5.5,
    width: 0.999986,
    height: 2,
    rx: 0.499993,
    transform: "rotate(90 12 5.5)",
    fill: "#13BC10"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 5.5,
    width: 0.999986,
    height: 2,
    rx: 0.499993,
    transform: "rotate(90 2 5.5)",
    fill: "#13BC10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.40005 5.99997C7.40005 6.77315 6.77326 7.39994 6.00006 7.39994C5.22685 7.39994 4.60006 6.77315 4.60006 5.99997C4.60006 5.2268 5.22685 4.6 6.00006 4.6C6.77326 4.6 7.40005 5.2268 7.40005 5.99997Z",
    stroke: "#13BC10",
    strokeWidth: 1.2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextMoveIcon);
export default __webpack_public_path__ + "static/media/next-move-icon.aae1e96d4f13aec5088659602a5ae4d5.svg";
export { ForwardRef as ReactComponent };